

















import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
    props: {
        free: {
            type: Boolean,
            default: false
        },
        teamState: {
            type: String as PropType<'free' | 'trial' | 'paid'>,
            required: true
        },
        feature: {
            type: String,
            required: true
        },
    },
    setup(props) {
        const featureState = props.free ? 'yes' :
                props.teamState === 'trial' ? 'trial' :
                        props.teamState === 'paid' ? 'yes' : 'no';

      // const featureName = props.feature + (props.free ? '' : ' (PRO)');
      const featureName = props.feature;

        return {
          featureName,
            featureState
        }
    }
});
